<template>
  <div class="ccui-app-box-iframe-operate-container">
    <breadcrumbSourcing :breadcrumb-data="breadcrumbData"></breadcrumbSourcing>
    <div class="ccui-app-iframe-container-detail">
      <div class="ccui-app-iframe-container-detail-body">
        <!-- <div v-if="relationWarningList.length > 0" class="tips">
          <div style="color: red">温馨提示：</div>
          <div v-for="(item, index) in relationWarningList" :key="index">
            {{ item }}
          </div>
        </div> -->
        <div class="ccui-tab-iframe">
          <div class="ccui-tab-wrapper">
            <el-button
              :type="tableTop == 1 ? 'table-top-active' : 'table-top'"
              size="mini"
              @click="tableTop = 1"
              >{{
                `技术评分${
                  subPackageFlag == "0" ? "" : "(包件：" + packName + ")"
                }`
              }}</el-button
            >
            <!-- <el-button
              :type="tableTop == 2 ? 'table-top-active' : 'table-top'"
              size="mini"
              @click="tableTop = 2"
              >供应商信用信息</el-button
            > -->
          </div>
        </div>
        <caigoufengxian
          v-if="tableTop == 2"
          :schemeId="schemeId"
        ></caigoufengxian>
        <el-table
          v-if="tableTop == 1"
          :data="tableData"
          max-height="410"
          ref="table"
          border
          empty-text="该评标项目中，没有有效的供应商投标信息！"
        >
          <el-table-column
            v-for="(item, index) in columns"
            :fixed="item.fixed"
            :key="index"
            :show-overflow-tooltip="true"
            v-bind="item"
          >
            <template slot="header">
              <template v-if="item.required">
                <span class="star">*</span>{{ item.label }}
              </template>
              <template v-else>
                {{ item.label }}
              </template>
            </template>
            <template v-if="item.labelChild && item.labelChild.length > 0">
              <el-table-column
                v-for="(child, indexch) in item.labelChild"
                :key="indexch"
                align="center"
                v-bind="child"
              >
                <template slot="header">
                  <div
                    :title="child.label"
                    class="el-tooltip vtip-text-ellipsis-2"
                  >
                    {{ child.label }}
                  </div>
                </template>
                <template
                  v-if="child.labelChild && child.labelChild.length > 0"
                >
                  <el-table-column
                    v-for="(childTwo, indexchTwo) in child.labelChild"
                    :key="indexchTwo"
                    align="center"
                    v-bind="childTwo"
                  >
                    <template slot="header">
                      <!-- <el-tooltip :content="childTwo.label"> -->
                      <div
                        :title="childTwo.label"
                        class="el-tooltip vtip-text-ellipsis-2"
                      >
                        {{ childTwo.label }}
                      </div>
                      <!-- </el-tooltip> -->
                    </template>
                    <!--                    <template-->
                    <!--                      v-if="-->
                    <!--                        childTwo.labelChild && childTwo.labelChild.length > 0-->
                    <!--                      "-->
                    <!--                    >-->
                    <template
                      v-if="
                        childTwo.labelChild && childTwo.labelChild.length > 0
                      "
                    >
                      <el-table-column
                        v-for="(childThree, indexchTwo) in childTwo.labelChild"
                        :key="indexchTwo"
                        align="center"
                        v-bind="childThree"
                      >
                        <template slot="header">
                          <div
                            :title="childThree.label"
                            class="el-tooltip vtip-text-ellipsis-2 tooltip-header"
                            :class="{
                              'tooltip-header-flow':
                                childThree.label.length > 15
                            }"
                          >
                            {{ childThree.label }}
                          </div>
                        </template>
                        <template slot-scope="scope">
                          <el-input
                            v-if="childThree.type == 'input'"
                            v-limitdecimal.two
                            v-model="scope.row[scope.column.property]"
                            @change="
                              changeScore(
                                $event,
                                scope.column.property,
                                scope.$index
                              )
                            "
                            :min="0"
                            size="mini"
                          ></el-input>
                        </template>
                      </el-table-column>
                    </template>

                    <!--                      <el-table-column-->
                    <!--                        v-for="(childThree,-->
                    <!--                        indexchThree) in childTwo.labelChild"-->
                    <!--                        :key="indexchThree"-->
                    <!--                        align="center"-->
                    <!--                        v-bind="childThree"-->
                    <!--                      >-->
                    <!--                        <template slot-scope="scope">-->
                    <!--                          <el-input-->
                    <!--                            v-if="child.type == 'input'"-->
                    <!--                            v-limitdecimal.two-->
                    <!--                            v-model="scope.row[scope.column.property]"-->
                    <!--                            @change="-->
                    <!--                              changeScore(-->
                    <!--                                $event,-->
                    <!--                                scope.column.property,-->
                    <!--                                scope.$index-->
                    <!--                              )-->
                    <!--                            "-->
                    <!--                            :min="0"-->
                    <!--                            size="mini"-->
                    <!--                          ></el-input>-->
                    <!--                        </template>-->
                    <!--                      </el-table-column>-->
                    <!--                    </template>-->
                  </el-table-column>
                </template>
              </el-table-column>
            </template>
            <template slot-scope="scope">
              <el-input
                maxlength="150"
                show-word-limit
                class="input-short word-limit input-width;"
                v-if="item.type == 'input'"
                v-model="scope.row.scoreDesc"
              ></el-input>
              <el-button
                v-else-if="item.type == 'link'"
                size="mini"
                type="text"
                @click="viewBidFile(scope.row)"
                >查看投标文件</el-button
              >
              <span v-else-if="item.money">{{
                scope.row[item.prop]
                  ? new BigNumber(scope.row[item.prop]).toFormat(2)
                  : ""
              }}</span>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="operate">
      <el-button
        type="text"
        icon="icon-ccui-save"
        v-preventReClick
        @click="dealExpertSupScore"
        >保存</el-button
      >
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="供应商投标详细信息"
      width="1200px"
      v-if="dialogVisible"
    >
      <supplierBidDetails
        :supQuoteId="formData.supQuoteId"
        :supPackQuoteId="formData.supPackQuoteId"
        :supCode="formData.supCode"
        source="default"
      ></supplierBidDetails>
      <div slot="footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="dialogVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import BigNumber from "bignumber.js";
import supplierBidDetails from "@/app/sourcingFlow/views/supplierBidDetails.vue";
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import caigoufengxian from "./components/caigoufengxian";
import {
  qryExpertSupPackQuoteToScoreApi,
  dealExpertSupScoreApi,
  qryExpertSupPackQuoteScoreApi,
  listPurchaseSchemePackageApi,
  bidSupPersonnelRelationWarning
} from "@/app/sourcingFlow/api/expertEvaluation.js";

export default {
  name: "addSkiiScore",
  components: {
    supplierBidDetails,
    breadcrumbSourcing,
    caigoufengxian
  },
  props: {
    type: {
      type: Number,
      default: 0 // type 0:新增 1：编辑
    },
    packId: {
      type: String,
      default: "" // 包件packId
    }
  },
  data() {
    return {
      BigNumber: BigNumber,
      tableTop: 1,
      breadcrumbData: {
        titname: "技术评分"
      },
      relationWarningList: [],
      tableData: [],
      maxHeight: "",
      headers: [],
      dialogVisible: false,
      formData: {
        supQuoteId: 0, // 供应商报价ID
        supPackQuoteId: "",
        supCode: "" // 供应商编号
      },
      columns: [],
      columnCopy: [
        {
          prop: "id",
          label: "序号",
          "min-width": 40,
          fixed: true
        },
        {
          prop: "supName",
          label: "供应商",
          "min-width": 100,
          fixed: true
        },
        {
          prop: "supTypeNewName",
          label: "供应商类型",
          align: "center",
          width: 100
        },
        {
          prop: "supLevelName",
          label: "供应商等级",
          align: "center",
          width: 100
        },
        {
          prop: "supCategoryName",
          label: "供应商分类",
          align: "center",
          width: 100
        },
        {
          prop: "priceAmount",
          label:
            "投标金额（" + sessionStorage.getItem("moneyTypeName") + "）含税",
          width: 180,
          money: true
        },
        {
          prop: "查看投标文件",
          label: "投标文件",
          width: 120,
          type: "link"
        },
        {
          prop: "sscScoreItemBOS",
          label: "技术",
          labelChild: [],
          align: "center",
          required: true
        },
        {
          prop: "supScore",
          label: "汇总得分",
          "min-width": 60
        },
        {
          prop: "scoreDesc",
          label: "打分说明",
          "min-width": 100,
          type: "input",
          required: true
        }
      ],
      packName: "",
      schemeId: JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId,
      subPackageFlag: "1" // 是否分包 1分包0不分包
    };
  },
  created() {
    this.maxHeight = window.innerHeight - 320;
    console.log(this.maxHeight);
  },
  mounted() {
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    if (this.purchaseType == "50" || this.purchaseType == "53") {
      // this.columnCopy.splice(2, 1);
      this.columnCopy.splice(5, 1);
      this.columns = this.columnCopy;
    } else {
      this.columns = this.columnCopy;
    }
    this.cumputeData();
    this.getPackData();
    this.getSupPersonnelRelationWarning();
  },
  methods: {
    init() {
      this.cumputeData();
      this.getPackData();
    },
    getSupPersonnelRelationWarning() {
      let param = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        step: "6",
        languageFlag: ""
      };
      bidSupPersonnelRelationWarning(param).then(res => {
        if (res.data.code == "0") {
          this.relationWarningList = res.data.data.compareResult;
        }
      });
    },
    cumputeData() {
      if (
        this.$router.history.current.query.type &&
        this.$router.history.current.query.type == "1"
      ) {
        qryExpertSupPackQuoteScoreApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: this.packId
            ? this.packId
            : this.$router.history.current.query.packId,
          joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .joinExpertId,
          scoreItem: "0"
        }).then(res => {
          if (res.data.data && res.data.data.length > 0) {
            let labelChild = [];
            res.data.data.forEach((item, index) => {
              item.supScore = item.supScore
                ? new BigNumber(item.supScore).toFormat(2)
                : item.supScore;
              item.id = index + 1;
              if (!item.supScore) {
                item.supScore = 0;
              }
              item.sscScoreBOS = item.sscSupScoreBOS;
              item.sscScoreBOS.forEach(sscScoreBOItem => {
                sscScoreBOItem.sscScoreItemBOS =
                  sscScoreBOItem.sscSupScoreItemBOS;
                sscScoreBOItem.sscScoreItemBOS.forEach(sscScoreItemBO => {
                  if (
                    !sscScoreItemBO.supScore &&
                    sscScoreItemBO.supScore !== 0
                  ) {
                    sscScoreItemBO.supScore = "";
                  }
                  item.scoreRule = sscScoreItemBO.scoreRule;
                  item.scoreWeight = sscScoreItemBO.scoreWeight;
                  item.scoreStandard = sscScoreItemBO.scoreStandard;
                  let props = "supScore-" + sscScoreItemBO.scoreItemId;
                  item[props] = sscScoreItemBO.supScore
                    ? new BigNumber(sscScoreItemBO.supScore).toFormat(2)
                    : sscScoreItemBO.supScore;
                  // 细则权重
                  let scoreWeightProps =
                    "maxScoreWeight-" +
                    sscScoreItemBO.scoreRule +
                    "-" +
                    sscScoreItemBO.scoreItemId;
                  item[scoreWeightProps] = sscScoreItemBO.scoreWeight;
                  if (
                    labelChild.filter(item => {
                      return (
                        item.prop == "supScore-" + sscScoreItemBO.scoreItemId
                      );
                    }).length == 0
                  ) {
                    labelChild.push({
                      prop: props,
                      label: sscScoreItemBO.scoreRule,
                      width: 150,
                      type: "input",
                      labelChild: [
                        {
                          prop: props,
                          label: "细则权重:" + sscScoreItemBO.scoreWeight,
                          width: 150,
                          labelChild: [
                            {
                              prop: props,
                              label: sscScoreItemBO.scoreStandard,
                              width: 150,
                              type: "input"
                            }
                          ]
                          // labelChild: [
                          //   {
                          //     prop: props,
                          //     label: "评分规则内容",
                          //     width: 120
                          //   }
                          // ]
                        }
                      ]
                    });
                  }
                });
              });
            });
            console.log(labelChild, "labelChild");
            if (labelChild.length < 3) {
              if (this.purchaseType == "50" || this.purchaseType == "53") {
                delete this.columns[8].width;
              } else {
                // delete this.columns[6].width;
              }
            }
            this.columns[7].labelChild = labelChild;
            this.tableData = res.data.data;
            this.$nextTick(() => {
              this.$refs.table.doLayout();
            });
          }
        });
      } else {
        qryExpertSupPackQuoteToScoreApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: this.packId
            ? this.packId
            : this.$router.history.current.query.packId,
          scoreItem: "0"
        }).then(res => {
          if (res.data.data && res.data.data.length > 0) {
            let labelChild = [];
            res.data.data.forEach((item, index) => {
              item.supScore = item.supScore
                ? new BigNumber(item.supScore).toFormat(2)
                : item.supScore;
              item.id = index + 1;
              if (!item.supScore) {
                item.supScore = 0;
              }
              item.sscScoreBOS.forEach(sscScoreBOItem => {
                sscScoreBOItem.sscScoreItemBOS.forEach(sscScoreItemBO => {
                  if (
                    !sscScoreItemBO.supScore &&
                    sscScoreItemBO.supScore !== 0
                  ) {
                    sscScoreItemBO.supScore = "";
                  }
                  item.scoreRule = sscScoreItemBO.scoreRule;
                  item.scoreWeight = sscScoreItemBO.scoreWeight;
                  item.scoreStandard = sscScoreItemBO.scoreStandard;
                  let props = "supScore-" + sscScoreItemBO.scoreItemId;
                  item[props] = sscScoreItemBO.supScore
                    ? new BigNumber(sscScoreItemBO.supScore).toFormat(2)
                    : sscScoreItemBO.supScore;
                  // 细则权重
                  let scoreWeightProps =
                    "maxScoreWeight-" +
                    sscScoreItemBO.scoreRule +
                    "-" +
                    sscScoreItemBO.scoreItemId;
                  item[scoreWeightProps] = sscScoreItemBO.scoreWeight;
                  if (
                    labelChild.filter(item => {
                      return (
                        item.prop == "supScore-" + sscScoreItemBO.scoreItemId
                      );
                    }).length == 0
                  ) {
                    labelChild.push({
                      prop: props,
                      label: sscScoreItemBO.scoreRule,
                      width: 150,
                      type: "input",
                      labelChild: [
                        {
                          prop: props,
                          label: "细则权重:" + sscScoreItemBO.scoreWeight,
                          width: 150,
                          labelChild: [
                            {
                              prop: props,
                              label: sscScoreItemBO.scoreStandard,
                              width: 150,
                              type: "input"
                            }
                          ]
                          // labelChild: [
                          //   {
                          //     prop: props,
                          //     label: "评分规则内容",
                          //     width: 120
                          //   }
                          // ]
                        }
                      ]
                    });
                  }
                });
              });
            });
            if (this.purchaseType == "50" || this.purchaseType == "53") {
              this.columns[6].labelChild = labelChild;
            } else {
              this.columns[7].labelChild = labelChild;
            }
            console.log(this.columns, "columns");
            this.tableData = res.data.data;
            this.$nextTick(() => {
              this.$refs.table.doLayout();
            });
          }
        });
      }
    },
    getPackData() {
      listPurchaseSchemePackageApi({
        pageNo: 1,
        pageSize: 100,
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // subPackageFlag 是否分包 1分包0不分包
        this.subPackageFlag = res.data.data.subPackageFlag;
        let packId = this.packId
          ? this.packId
          : this.$router.history.current.query.packId;
        res.data.data.purchaseSchemePackageList.forEach(item => {
          if (item.packId == packId) {
            this.packName = item.packName;
          }
        });
      });
    },
    viewBidFile(row) {
      this.formData.supQuoteId = row.supQuoteId;
      this.formData.supPackQuoteId = row.supPackQuoteId;
      this.formData.supCode = row.supCode;
      this.dialogVisible = true;
    },
    // 改变分数计算汇总得分
    changeScore(value, prop, index) {
      // 直接验证不能大于权重并提示
      let total = 0;
      let flag = true;
      let message = "";
      try {
        for (let key in this.tableData[index]) {
          if (key.includes("supScore-")) {
            // 不能大于权重大小
            for (let keyWeight in this.tableData[index]) {
              if (keyWeight.includes("maxScoreWeight-")) {
                let scoreItemId = key.substring(9);
                let scoreWeightItemId = keyWeight.substring(
                  keyWeight.lastIndexOf("-") + 1
                );
                let scoreRule = keyWeight.substring(
                  15,
                  keyWeight.lastIndexOf("-")
                );
                if (scoreItemId === scoreWeightItemId) {
                  if (
                    Number(this.tableData[index][key]) >
                    Number(this.tableData[index][keyWeight])
                  ) {
                    flag = false;
                    this.tableData[index][prop] = 0;
                    message =
                      "第" +
                      (index + 1) +
                      "行的" +
                      scoreRule +
                      "的得分不允许大于细则权重" +
                      this.tableData[index][keyWeight] +
                      "分，谢谢您的配合！";
                    throw Error();
                  }
                }
              }
            }
            //total += Number(this.tableData[index][key]);
            total = window.$computeUtil.getPlus(
              total,
              this.tableData[index][key] || "0"
            );
          }
        }
      } catch (e) {
        console.log(e);
      }
      total = total ? new BigNumber(total).toFormat(2) : total;
      if (flag) {
        this.$set(this.tableData[index], "supScore", total);
      } else {
        this.$message({
          message: message,
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    // 保存
    dealExpertSupScore() {
      if (this.tableData.length === 0) {
        this.$message({
          message: `供应商已全部淘汰，请联系采购承办人进行流标操作`,
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      } else {
        let sscExpertSupScoreBOS = [];
        let flag = true;
        let message = "";
        try {
          this.tableData.forEach((item, index) => {
            let scoreItemIdArr = [];
            let obj = {};
            obj.supCode = item.supCode;
            obj.supName = item.supName;
            obj.supScore = item.supScore;
            obj.scoreDesc = item.scoreDesc;
            obj.scoreItem = "0";
            let sscSupScoreItemBOS = [];
            // if (!item.scoreDesc) {
            //   flag = false;
            //   message = "第" + (index + 1) + "行的打分说明不能为空";
            //   throw Error();
            // }
            for (let key in item) {
              if (key.includes("supScore-")) {
                // 不能大于权重大小
                for (let keyWeight in item) {
                  if (keyWeight.includes("maxScoreWeight-")) {
                    let scoreItemId = key.substring(9);
                    let scoreWeightItemId = keyWeight.substring(
                      keyWeight.lastIndexOf("-") + 1
                    );
                    let scoreRule = keyWeight.substring(
                      15,
                      keyWeight.lastIndexOf("-")
                    );
                    if (scoreItemId === scoreWeightItemId) {
                      if (
                        Number(this.tableData[index][key]) >
                        Number(this.tableData[index][keyWeight])
                      ) {
                        flag = false;
                        message =
                          "第" +
                          (index + 1) +
                          "行的" +
                          scoreRule +
                          "的得分不允许大于细则权重" +
                          this.tableData[index][keyWeight] +
                          "分，谢谢您的配合！";
                        throw Error();
                      }
                    }
                  }
                }
                if (
                  !Number(this.tableData[index][key]) &&
                  this.tableData[index][key] !== 0 &&
                  this.tableData[index][key] !== "0.00"
                ) {
                  console.log(this.tableData[index][key]);
                  flag = false;
                  message = "第" + (index + 1) + "行的评分规则内容不能为空";
                  throw Error();
                }
                if (!scoreItemIdArr.includes(key)) {
                  scoreItemIdArr.push(key);
                  let sscScoreObj = {};
                  sscScoreObj.scoreItemId = key.substring(9);
                  sscScoreObj.supScore = this.tableData[index][key];
                  sscSupScoreItemBOS.push(sscScoreObj);
                }
              }
              if (
                !item.scoreDesc ||
                (key == "scoreDesc" && !this.tableData[index][key])
              ) {
                flag = false;
                message = "第" + (index + 1) + "行的打分说明不能为空";
                throw Error();
              }
            }
            obj.sscSupScoreItemBOS = sscSupScoreItemBOS;
            sscExpertSupScoreBOS.push(obj);
          });
        } catch (e) {
          console.log(e);
        }
        if (flag) {
          let param = {
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            packId: this.packId
              ? this.packId
              : this.$router.history.current.query.packId,
            packName: this.packName,
            joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .joinExpertId,
            expertName: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .expertName,
            purStep: this.$router.history.current.query.menuKey,
            scoreType: "0",
            sscExpertSupScoreBOS: sscExpertSupScoreBOS
          };
          dealExpertSupScoreApi(param).then(res => {
            if (res.data.code == "0") {
              this.init();
              this.$router.push({
                name: "skiiScoreList",
                query: {
                  a: this.$router.history.current.query.a,
                  menuKey: this.$router.history.current.query.menuKey,
                  active: this.$route.query.active
                }
              });
              this.$message({
                message: "技术评分保存成功",
                type: "success",
                duration: 3000,
                showClose: true,
                ccuiCustom: true
              });
            }
          });
        } else {
          this.$message({
            message: message,
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.tips {
  color: red;
  padding: 20px 0 0 20px;
}
.el-table {
  th {
    .cell {
      white-space: nowrap !important;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }
}
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    padding: 0;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
/deep/ .el-table--border {
  th:last-of-type.gutter {
    display: table-cell !important;
    width: 0px !important;
  }
}
/deep/ .vtip-text-ellipsis-2 {
  // width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
  padding-right: 2px;
}
.tooltip-header {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  margin: 10px 0;
  line-height: 20px;
}
/deep/.el-button--table-top {
  font-weight: 600;
}
</style>
<style lang="scss">
.iframeMain-box .dic-ccui-app-main {
  padding-bottom: 1px !important;
}
</style>
